module.exports = __webpack_public_path__ + "static/img/200330.c20e5911.png";